'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment, Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import Button from '@material-ui/core/Button';
import FullScreenModal from 'Modals/FullScreenModal';
import bemit from 'Functions/bemit';
const MIN_DISTANCE = 50;
export default function ListenerWrapper(props) {
  const [window_w, setWindowW] = useState(window.innerWidth);
  useEffect(function () {
    window.addEventListener('resize', handleResize);
    function handleResize() {
      setWindowW(window.innerWidth);
    }
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return /*#__PURE__*/React.createElement(Slider, _extends({}, props, {
    _window_w: window_w
  }));
}
class Slider extends Component {
  state = {
    active_element: this.props.type === 'custom' ? this.props.elements[0] : this.props.images[0],
    translate: 0,
    ready: false,
    id: uniqid(),
    caption: '',
    modal: false
  };
  ref = React.createRef();
  progress_ref = React.createRef();
  REFRESH_INTERVAL = 300;
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.max_refreshs = 4;
    if (props.images?.[0] && props['custom-captions']) {
      const first_img = props.images?.[0];
      component.setState({
        caption: first_img?.caption || first_img?.alt
      });
    }
    component.checkWidth();

    // Update slider width in case of slider width change
    component.setRefresh();
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props._window_w !== prev_props._window_w) {
      component.checkWidth();
      component.max_refreshs = 3;
      component.setRefresh();
    }
  }
  goToInitialElement = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.interacted) return;
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    const element = elements[props.initial_img];
    if (element && element !== state.active_element) {
      component.goTo(null, element, props.initial_img);
    }
  };
  setRefresh = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.ready && !component.ref?.current) return;
    if (component.check_timeout) {
      window.clearTimeout(component.check_timeout);
      component.check_timeout = undefined;
    }
    if (component.refreshs_stable && props.initial_img !== undefined) {
      component.goToInitialElement();
    }
    if (component.max_refreshs > 0 === false) {
      component.checkWidth();
      component.refreshs_stable = true;
      component.goToInitialElement();
      return;
    }
    component.check_timeout = window.setTimeout(function () {
      component.check_timeout = undefined;
      component.max_refreshs -= 1;
      component.checkWidth();
      component.setRefresh(null);
    }, component.REFRESH_INTERVAL);
  };
  checkWidth = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const width = component.ref?.current?.getBoundingClientRect()?.width;
    if (component.width === width) return component.refreshs_stable = true;
    component.refreshs_stable = false;
    component.width = width;
    component.setTranslate();
    if (width > 0) {
      component.setState({
        ready: true
      });
    }
  };
  setTranslate = active_element => {
    const component = this,
      props = this.props,
      state = this.state;
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    const current_element = active_element || state.active_element;
    if (!current_element) {
      component.refresh = window.setTimeout(function () {
        component.refresh = undefined;
        component.setTranslate();
      }, 300);
      return;
    }
    if (component.width > 0 === false) {
      return;
    }
    let offset = 0;
    if (current_element.id !== elements[0].id) {
      const index = elements.findIndex(el => el.id === current_element.id);
      offset = index * component.width;
    }
    if (state.translate !== offset) {
      component.setState({
        translate: offset
      });
    }
  };
  next = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onUserInteraction === 'function') {
      props.onUserInteraction();
    }
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    const index = elements.findIndex(el => el.id === state.active_element.id);
    if (index < elements.length - 1) {
      component.setState({
        active_element: elements[index + 1],
        caption: elements[index + 1]?.caption || elements[index + 1]?.alt
      });
      component.setTranslate(elements[index + 1]);
    }
  };
  previous = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onUserInteraction === 'function') {
      props.onUserInteraction();
    }
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    const index = elements.findIndex(el => el.id === state.active_element.id);
    if (index > 0) {
      component.setState({
        active_element: elements[index - 1],
        caption: elements[index - 1]?.caption || elements[index - 1]?.alt
      });
      component.setTranslate(elements[index - 1]);
    }
  };
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trg: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trg: undefined
    });
  };
  goTo = (e, element, i) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (e && typeof props.onUserInteraction === 'function') {
      props.onUserInteraction();
    }
    component.setState({
      active_element: element
    });
    component.setTranslate(element);
  };
  handleTouchStart = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const touch = e.touches?.[0];
    if (!touch) return;
    component.swipe = {
      x: touch.clientX
    };
    component.swiped = false;
  };
  handleTouchMove = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onUserInteraction === 'function') props.onUserInteraction();
    if (e.changedTouches?.length > 0) {
      component.swipe.swiping = true;
    }
  };
  handleTouchEnd = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const touch = e.changedTouches?.[0];
    if (!touch) return;
    const absX = Math.abs(touch.clientX - component.swipe.x);
    if (component.swipe.swiping && absX > MIN_DISTANCE) {
      const direction = touch.clientX < component.swipe.x ? 'right' : 'left';
      component.swiped = true;
      if (direction === 'left') {
        component.previous();
      } else {
        component.next();
      }
    }
    component.swipe = {};
  };
  handleThumbnailTouchStart = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const touch = e.touches?.[0];
    if (!touch) return;
    component.thumbnail_swipe = {
      x: touch.clientX
    };
    component.thumbnail_swiped = false;
  };
  handleThumbnailTouchMove = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (typeof props.onUserInteraction === 'function') props.onUserInteraction();
    if (e.changedTouches?.length > 0) {
      component.thumbnail_swipe.swiping = true;
    }
  };
  handleThumbnailTouchEnd = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const touch = e.changedTouches?.[0];
    if (!touch) return;
    const absX = Math.abs(touch.clientX - component.thumbnail_swipe.x);
    if (component.thumbnail_swipe.swiping && absX > MIN_DISTANCE) {
      const direction = touch.clientX < component.thumbnail_swipe.x ? 'right' : 'left';
      component.thumbnail_swiped = true;
      if (direction === 'left') {
        component.previous();
      } else {
        component.next();
      }
    }
    component.thumbnail_swipe = {};
  };
  getProgressOffset = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!component.ref?.current) return;
    const slider_w = component.ref.current.getBoundingClientRect().width;
    if (slider_w > 100 === false) return;
    const prog_w = component.progress_ref.current.getBoundingClientRect().width;
    if (prog_w > slider_w === false) return;
    const thumbnail_width = 101;
    const max_displayed = parseInt(slider_w / thumbnail_width);
    if (max_displayed > 0 === false) return;
    const active_element = state.active_element;
    if (!active_element) return;
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    if (elements?.length > 0 === false) return;
    const active_i = elements.findIndex(e => e.id === active_element.id);
    const overflow = prog_w - slider_w;
    const side_overflow = overflow / 2;
    let visible_slides_count = parseInt(slider_w / thumbnail_width);

    // vu qu'on centre la liste s'il y a un nombre impair de slides, on aura
    // une thumbnail au centre de la liste, sinon l'interstice entre 2 thumbnails
    // et un nombre pair de thumbnails réparties autour
    // donc même si on peut caser un nombre impairs de thumbnails,
    // s'il y a un nombre pair de thumnail on en aura un nombre pair totalement
    // visibles et 2 sur les bords équitablement coupées
    if (elements.length % 2 === 0 && visible_slides_count % 2 !== 0) {
      visible_slides_count -= 1;
    }
    const outside_slides_count = elements.length - visible_slides_count;

    // puisqu'on centre, le nombre de slider en dehors est forcément pair
    const first_visible_slide_i = outside_slides_count / 2 + 1 - 1;
    const last_visible_slide_i = first_visible_slide_i + visible_slides_count - 1;

    // thumbnail visible, on laisse la vue centrée
    if (active_i >= first_visible_slide_i && active_i <= last_visible_slide_i) {
      return 0;
    }

    // premier élément, on calle à gauche modulo le padding
    if (active_i === 0) return side_overflow - 8;

    // dernier élément, on calle à droite modulo le padding
    if (active_i === elements.length - 1) return -(side_overflow - 8);

    // l'image est à gauche de la vue
    if (active_i < first_visible_slide_i) {
      return side_overflow - active_i * thumbnail_width;
    }
    const slides_until_active = active_i - last_visible_slide_i;
    let _offset_fix = 0;

    // si on affiche un nombre pair de thumbnails, il y en a deux sur les côtés
    // qui dépassent, en ajoutant cette partie on calle la thumnail
    // courante à droite, le problème ne se présente pas
    // s'il y a un nombre impair de thumbnails
    if (visible_slides_count % 2 === 0) {
      const overflowing = slider_w - visible_slides_count * thumbnail_width;
      _offset_fix = overflowing / 2;
    }
    return -slides_until_active * thumbnail_width + _offset_fix;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const active_element = state.active_element;
    let modifiers = ['auto'].concat(props.bemit);
    const elements = props.type === 'custom' ? props.elements || [] : props.images || [];
    if (elements.length === 0) return null;
    if (active_element.id === elements[0].id) {
      modifiers.push('first');
    }
    if (active_element.id === elements[elements.length - 1].id) {
      modifiers.push('last');
    }
    if (props['with-imgs-title']) modifiers.push('with-imgs-title');
    if (props['custom-captions']) modifiers.push('with-captions');
    if (state.ready === true) modifiers.push('ready');
    let elements_list = [];
    const touch_events = props['with-overlay'] ? {} : {
      onTouchStart: component.handleTouchStart,
      onTouchMove: component.handleTouchMove,
      onTouchEnd: component.handleTouchEnd
    };
    if (props.type === 'custom') {
      elements_list = elements.map(function (element) {
        let output = /*#__PURE__*/React.createElement("div", {
          className: "o-img-slider__element",
          key: element.id,
          onTouchStart: touch_events.onTouchStart,
          onTouchMove: touch_events.onTouchMove,
          onTouchEnd: touch_events.onTouchEnd
        }, element.content);
        return output;
      });
    } else {
      elements_list = elements.map(function (image) {
        let output = /*#__PURE__*/React.createElement("div", {
          className: "o-img-slider__element",
          key: image.id
        }, /*#__PURE__*/React.createElement("img", {
          className: "o-img-slider__img",
          src: image.src,
          alt: image.alt,
          id: state.id + '-' + image.id,
          onTouchStart: touch_events.onTouchStart,
          onTouchMove: touch_events.onTouchMove,
          onTouchEnd: touch_events.onTouchEnd
        }), props['with-imgs-title'] && image.alt?.trim?.() ? /*#__PURE__*/React.createElement("span", {
          className: "o-img-slider__img-title"
        }, image.alt) : undefined);
        return output;
      });
    }
    const styles = {
      transform: 'translateX(-' + state.translate + 'px)',
      width: 'calc(100% * ' + elements.length + ')'
    };
    const progress_thumbnails = props['with-thumbnails'] === true;
    if (progress_thumbnails) modifiers.push('with-thumbnails');
    const progress_offset = progress_thumbnails ? component.getProgressOffset() || 0 : undefined;
    const progress_controls = props['hide-progress'] === true ? undefined : elements.map(function (element, i) {
      let class_name = 'o-img-slider__progress-control';
      if (element.id === active_element.id) {
        class_name += ' active';
      }
      const output = /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: class_name,
        key: element.id,
        onClick: e => component.goTo(e, element, i)
      }, /*#__PURE__*/React.createElement("span", {
        className: "u-readers-only"
      }, "Image n\xB0 ", i), !progress_thumbnails ? undefined : props.type === 'custom' ? /*#__PURE__*/React.createElement("div", {
        className: "o-img-slider__progress-img-container"
      }, element.content) : /*#__PURE__*/React.createElement("img", {
        src: element.src,
        alt: 'Slide n°' + (i + 1),
        className: "o-img-slider__progress-img",
        onTouchStart: component.handleThumbnailTouchStart,
        onTouchMove: component.handleThumbnailTouchMove,
        onTouchEnd: component.handleThumbnailTouchEnd
      }));
      return output;
    });
    const slider_events = props['with-overlay'] ? {
      onTouchStart: component.handleTouchStart,
      onTouchMove: component.handleTouchMove,
      onTouchEnd: component.handleTouchEnd
    } : {};
    let output = /*#__PURE__*/React.createElement("div", {
      className: bemit('o-img-slider', modifiers),
      ref: component.ref,
      onTouchStart: slider_events.onTouchStart,
      onTouchMove: slider_events.onTouchMove,
      onTouchEnd: slider_events.onTouchEnd
    }, props.children ? /*#__PURE__*/React.createElement("div", {
      className: "o-img-slider__custom-content",
      onTouchStart: component.handleTouchStart,
      onTouchMove: component.handleTouchMove,
      onTouchEnd: component.handleTouchEnd
    }, props.children) : undefined, /*#__PURE__*/React.createElement("div", {
      className: "o-img-slider__translate",
      style: styles
    }, elements_list), props['custom-captions'] ? /*#__PURE__*/React.createElement("span", {
      className: "o-img-slider__caption"
    }, state.caption) : undefined, props['with-zoom'] ? /*#__PURE__*/React.createElement(Button, {
      className: "o-img-slider__fullscreen-toggle",
      onClick: component.openModal
    }, /*#__PURE__*/React.createElement("svg", {
      className: "o-img-slider__fullscreen-toggle-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "8"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "21",
      y1: "21",
      x2: "16.65",
      y2: "16.65"
    })), "Agrandir la photo") : undefined, props['hide-arrows'] !== true ? /*#__PURE__*/React.createElement(Button, {
      className: "o-img-slider__left",
      onClick: component.previous
    }, /*#__PURE__*/React.createElement("span", {
      className: "u-readers-only"
    }, "Pr\xE9c\xE9dent")) : undefined, props['hide-arrows'] !== true ? /*#__PURE__*/React.createElement(Button, {
      className: "o-img-slider__right",
      onClick: component.next
    }, /*#__PURE__*/React.createElement("span", {
      className: "u-readers-only"
    }, "Suivant")) : undefined, progress_controls && !progress_thumbnails ? /*#__PURE__*/React.createElement("div", {
      className: "o-img-slider__progress"
    }, progress_controls) : undefined, props['with-zoom'] ? /*#__PURE__*/React.createElement(FullScreenModal, {
      open: state.modal,
      title: active_element?.alt,
      onClose: component.closeModal,
      trigger_src: state.modal_trg
    }, /*#__PURE__*/React.createElement("img", {
      className: "o-img-slider__fullscreen-img",
      src: active_element?.src
    })) : undefined);
    if (progress_thumbnails && progress_controls) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, output, /*#__PURE__*/React.createElement("div", {
        className: "o-img-slider__outside-progress",
        ref: component.progress_ref
      }, /*#__PURE__*/React.createElement("div", {
        className: "o-img-slider__progress is-outside",
        style: {
          transform: 'translateX(' + progress_offset + 'px)'
        }
      }, progress_controls)));
    }
    return output;
  }
}
Slider.propTypes = {
  'with-zoom': PropTypes.bool,
  'hide-arrows': PropTypes.bool,
  'hide-progress': PropTypes.bool,
  elements: PropTypes.array,
  images: PropTypes.array,
  bemit: PropTypes.array,
  transition: PropTypes.string
};
Slider.defaultProps = {
  'with-zoom': false,
  'hide-arrows': false,
  'hide-progress': false,
  classes: [],
  bemit: [],
  transition: '600'
};
